import { ClientCard } from './ClientCard'
import type { Client } from '../../types/database.types'

interface ClientListProps {
  clients: (Client & { assignment_count?: number })[]
  isLoading?: boolean
  onEditClient?: (client: Client) => void
  onArchiveClient?: (client: Client) => void
  onResendInvitation?: (client: Client) => void
  resendingClientId?: string | null
  emptyMessage?: string
}

export function ClientList({
  clients,
  isLoading = false,
  onEditClient,
  onArchiveClient,
  onResendInvitation,
  resendingClientId,
  emptyMessage = 'No clients found',
}: ClientListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-gray-200 rounded-xl h-48" />
          </div>
        ))}
      </div>
    )
  }

  if (clients.length === 0) {
    return (
      <div className="text-center py-12">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <p className="mt-4 text-gray-600">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {clients.map((client) => (
        <ClientCard
          key={client.id}
          client={client}
          onEdit={onEditClient ? () => onEditClient(client) : undefined}
          onArchive={
            onArchiveClient ? () => onArchiveClient(client) : undefined
          }
          onResendInvitation={
            onResendInvitation ? () => onResendInvitation(client) : undefined
          }
          isResending={resendingClientId === client.id}
        />
      ))}
    </div>
  )
}
